import { render, staticRenderFns } from "./InlineProductBrowser.vue?vue&type=template&id=0c1fff8a&scoped=true"
import script from "./InlineProductBrowser.vue?vue&type=script&lang=js"
export * from "./InlineProductBrowser.vue?vue&type=script&lang=js"
import style0 from "./InlineProductBrowser.vue?vue&type=style&index=0&id=0c1fff8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1fff8a",
  null
  
)

export default component.exports